import React from 'react';

import {
  GameDevelopment,
  SoundDesign,
  CharacterCreation,
  Model3d,
} from '../../assets/services';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ImageHeader from '../../components/ImageHeader';

import {
  Container,
  Content,
  DescriptionContainer,
  DescriptionItem,
  JobsList,
  JobItem,
  ContainerInfos,
  DiveInto,
  WorkWithUs,
} from './styles';

const WhatWeDo: React.FC = () => {
  return (
    <>
      <Header />

      <ImageHeader title="O QUE FAZEMOS" goToDiv="learn-more" />

      <Container id="learn-more">
        <DescriptionContainer>
          <DescriptionItem>
            <h4>DIVERSÃO</h4>
            <span>
              Desenvolvemos jogos digitais atrativos para celular e computador
              com foco no entretenimento, buscando proporcionar boas
              experiências ao usuários.
            </span>
          </DescriptionItem>
          <DescriptionItem>
            <h4>EDUCAÇÃO</h4>
            <span>
              Desenvolvemos jogos educativos, com objetivo de melhorar a
              didática e o aprendizado em sala de aula. Mostrando que aprender
              também pode ser divertido!
            </span>
          </DescriptionItem>
        </DescriptionContainer>

        <Content>
          <h1>SERVIÇOS</h1>
          <p>
            Transformamos pequenas ideias em soluções personalizadas e
            inovadoras. Conheça um pouco mais sobre os serviços que oferecemos.
          </p>
        </Content>

        <JobsList>
          <JobItem>
            <GameDevelopment />
            <span>Criação de Jogos</span>
          </JobItem>

          <JobItem>
            <SoundDesign />
            <span>Sound Design</span>
          </JobItem>

          <JobItem>
            <CharacterCreation />
            <span>Criação de Personagem</span>
          </JobItem>

          <JobItem>
            <Model3d />
            <span>Modelagem 3D</span>
          </JobItem>
        </JobsList>

        <ContainerInfos>
          <DiveInto>
            <h1>
              MERGULHE EM
              <br />
              NOSSOS PROJETOS
            </h1>
            <div>
              <a href="localhost">Saiba mais</a>
            </div>
          </DiveInto>
          <WorkWithUs>
            <h1>
              TRABALHE
              <br />
              CONOSCO
            </h1>
            <div>
              <a href="localhost">Saiba mais</a>
            </div>
          </WorkWithUs>
        </ContainerInfos>
      </Container>

      <Footer />
    </>
  );
};

export default WhatWeDo;
